import { StyledLink } from '@/components/Link'
import styles from './BillingContactSection.module.css'
import { externalLinks } from '@/utils/link'

export function BillingContactSection() {
  return (
    <div className={styles.content}>
      If you have any questions, visit our support site at{' '}
      <StyledLink variant="navigation" href={externalLinks.contactSupport()}>
        taxfyle.com/contact-us
      </StyledLink>{' '}
      or contact us at{' '}
      <StyledLink variant="navigation" href="mailto:success@taxfyle.com">
        success@taxfyle.com
      </StyledLink>
    </div>
  )
}
